export default __webpack_public_path__ + "static/media/ies_header_voces.8530edbd.png";